import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const SalesRegionListDetails = () => {
  const columns = [
    { label: 'Name', value: 'name' },
    { label: 'Country', value: 'country' },
    { label: 'Region Manager', value: 'region_manager_name' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];
  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/lead/sales-region/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['salesRegion']} />;
};

export default SalesRegionListDetails;